<template>
  <div class="about pt6 mt4">
    <v-wait for="info-load">
      <template slot="waiting">
        <div class="vh-100 dt w-100 aspect-ratio--object grey">
          <div class="dtc v-mid tc white ph3 ph4-l">
            <!-- <h1 class="f6 f2-m f-subheadline-l tc green">loading</h1> -->
          </div>
        </div>
      </template>
      <!-- Buttons -->
      <div class="mb5 f5">
        <InfoButton
          v-for="(cl, index) in contactLinks"
          v-bind:key="cl.contact_url"
          :button-url="cl.contact_url"
          :button-name="cl.contact_name"
          :extra-class="{ 'ml0 mr3': index == 0, mh3: index != 0 }"
        />
      </div>
      <!-- Info/bio -->
      <main
        class="w-70-ns w-70-m w-70-l f3 f2-ns f2-m f2-l"
        style="position:relative; z-index:1;"
      >
        <p class="w-100 green hyphenate">{{ intro }}</p>
        <br />
        <p class="w-100 green hyphenate" v-for="(b, index) in bio">{{ b }}</p>
        <br />
        <p class="w-100 green hyphenate">{{ currentProjectStatus }}</p>
        <br />
        <p class="w-100 green hyphenate">{{ contact }}</p>
      </main>
      <!-- Services -->
      <div class="mt5 f4 helvetica-ext">
        <div
          class="fl w-100 w-30-m w-30-ns w-30-l mb3 mb0-ns mb0-m mb0-l ph1 ph0-ns ph0-l ph0-m"
        >
          <span class="white mb2 dib">{{ servicesLabel }}</span>
          <ul>
            <li class="white mb2" v-for="(discipline, index) in disciplines">
              &#8211;{{ discipline }}
            </li>
          </ul>
        </div>
        <div
          class="fl w-100 w-20-m w-20-ns w-20-l mb3 mb0-ns mb0-m mb0-l ph1 ph0-ns ph0-l ph0-m tl-l tl-m"
        >
          <span class="white mb2 dib">{{ skillsLabel }}</span>
          <ul>
            <li class="white mb2" v-for="(expertise, index) in expertises">
              &#8211;{{ expertise }}
            </li>
          </ul>
        </div>
        <!-- Clients -->
        <div class="cf"></div>
        <div id="working-status" class="w-100 w-50-m w-30-ns w-30-l mt4">
          <p
            class="list-element white mb3 f4 hyphenate lh-copy"
            v-for="(ws, index) in workingStatus"
          >
            {{ ws }}
          </p>
        </div>
        <div class="cf"></div>
        <div class="fl w-100 w-50-m w-30-ns w-30-l mt4-m">
          <p class="white mt5 mb3 f5 hyphenate lh-copy">
            {{ pastClientsIntro }}
          </p>
        </div>
        <div class="cf"></div>
        <div class="w-100 mb3">
          <img
            class="fl w-50 w-25-m w-12-5-l"
            v-for="(ci, index) in pastClients"
            :src="ci"
          />
        </div>
        <!-- </div> -->
      </div>
      <div class="cf"></div>
      <!-- Ticker tape -->
      <div
        class="footer cf db mt3 mt5-ns mt5-m mt5-l w-100 h5 bg-black white helvetica-ext"
      >
        <marquee-text :repeat="2" :duration="footerAnimationDuration">
          <div class="mrq-row dib v-mid f5 w-100 noselect">
            &#169;<span class="year rotate-180">{{
              new Date().getFullYear()
            }}</span
            >&nbsp;Mario Guay&nbsp;{{ animatedFooterText }}&nbsp;
          </div>
        </marquee-text>
      </div>
    </v-wait>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'about',
  components: {
    InfoButton: () => import('../components/InfoButton.vue')
  },
  data() {
    return {
      animatedFooterText: '',
      awards: [],
      bio: [],
      contact: '',
      contactLinks: [],
      currentProjectStatus: [],
      disciplines: [],
      expertises: [],
      intro: '',
      pastClients: [],
      pastClientsIntro: '',
      servicesLabel: '',
      skillsLabel: '',
      workingStatus: [],
      footerAnimationDuration: 65
    };
  },
  methods: {},
  created() {
    var that = this;

    window.scrollTo(0, 0, 'auto');

    this.$wait.start('info-load');

    this.$store.dispatch('fetchInfoPage', {
      vm: this,
      cb: function(results) {
        console.log(results[0].data);
        var info = results[0].data;

        that.animatedFooterText =
          info.animated_footer_text != null ? info.animated_footer_text : '';
        that.currentProjectStatus =
          info.current_project_status != null
            ? info.current_project_status
            : '';

        that.footerAnimationDuration =
          (18 + that.animatedFooterText.length) * 0.2;

        that.intro = info.intro != null ? info.intro : '';

        for (var bio_index in info.bio) {
          that.bio.push(info.bio[bio_index].text);
        }

        for (var working_status_index in info.working_status) {
          that.workingStatus.push(
            info.working_status[working_status_index].text
          );
        }

        that.contact = info.contact != null ? info.contact : '';

        for (var contact_index in info.contact_links[0].items) {
          that.contactLinks.push({
            contact_name: info.contact_links[0].items[contact_index].link_name,
            contact_url: info.contact_links[0].items[contact_index].link_url.url
          });
        }

        // console.log(info.past_clients[0].items);

        for (var past_client_index in info.past_clients[0].items) {
          that.pastClients.push(
            info.past_clients[0].items[past_client_index].client_image.url
          );
        }

        console.log(that.pastClients);

        that.pastClientsIntro =
          info.past_clients_intro != null ? info.past_clients_intro : '';

        for (var award_index in info.awards[0].items) {
          that.awards.push(info.awards[0].items[award_index].award_name);
        }

        for (var discipline_index in info.disciplines[0].items) {
          that.disciplines.push(
            info.disciplines[0].items[discipline_index].discipline_name
          );
        }

        for (var expertise_index in info.expertises[0].items) {
          that.expertises.push(
            info.expertises[0].items[expertise_index].expertise_name
          );
        }

        that.servicesLabel =
          info.services_label != null ? info.services_label : '';
        that.skillsLabel = info.skills_label != null ? info.skills_label : '';

        that.$wait.end('info-load');
      }
    });
  }
};
</script>
<style scoped>
ul {
  list-style: none;
}
p.list-element {
  margin-left: 0;
  padding-left: 0;
}

.m-auto {
  /*margin: 0 auto 1rem;*/
  margin-top: 0;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 0;
}

.about {
  /*padding: 12rem 1.5rem 0;*/
  /*padding: 10rem 0 0;*/
  position: relative;
  z-index: 4;
  padding-top: 15rem;
}

.footer {
  /*height: 34rem;*/
  /*height: 44rem;*/

  /*height: 100vh;*/
  height: 50vh;

  padding: 0;
  /*padding-top: 38vh;*/
  /*padding-top: 21vw;*/
  position: relative;
}

.marquee-text-wrap {
  overflow: hidden;

  /*position: absolute;
    bottom: 0;*/

  max-width: 100%;
  /*font-size: 45vw;*/
}

.mrq-row {
  /*font-size: 46vw;*/
  /*font-size: 85vh;*/

  font-size: 20rem;
  /*font-size: 24rem;*/
}

.footer .year {
  display: inline-block;
}

.logo.white {
  position: absolute;
  top: 0;
  left: 1px;
  z-index: 120000;
  opacity: 0;
  /*-webkit-transition: opacity 0.05s linear;
    -moz-transition: opacity 0.05s linear;
    -o-transition: opacity 0.05s linear;
    transition: opacity 0.05s linear;*/
}

.logo.show-white {
  opacity: 1;
}

@media screen and (min-width: 60em) {
  .w-12-5-l {
    width: 12.5%;
  }
}

@media screen and (min-width: 30em) {
  .about {
    padding-top: 8rem;
  }

  /* a.btn {
    max-width: 580px;
  } */

  #working-status {
    /* margin-top: -10px; */
  }
}

@media screen and (max-width: 480px) {
  .mrq-row {
    font-size: 20rem;
  }
}
</style>
